"use client";

import { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import Pagination from "../../../../components/common/Pagination";
import PagesIndex from "../../../PagesIndex";
import { getApplicationMasterReport } from "../../../../redux/features/AddService";
import { useSelector } from "react-redux";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
import moment from "moment";
import FileExcel from "../../../../components/common/excelSheet/FileExcel";
import { Autocomplete } from "@mui/material";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import PrintReport from "../../../../components/common/printReport/PrintReport";
import { useReactToPrint } from "react-to-print";

export default function MasterReport() {
  const { getApplicationMasterReportList } = PagesIndex.useSelector(
    (state) => state?.admin,
  );
  const location = PagesIndex.useLocation();
  const fileName = "Sahay Application Master Report CSV";
  const [excel, setExcel] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rowPerPage, setRowPerPage] = useState("25");
  const dispatch = PagesIndex.useDispatch();
  const [filter, setFilter] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [filterReportData, setFilterReportData] = useState([]);
  const [selectDateData, setSelectDateData] = useState("");
  const [filterApplicantName, setFilterApplicantName] = useState("");
  const [filterMoholloName, setFilterMoholloName] = useState("");

  // Print Reports
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    dispatch(getApplicationMasterReport()).then((res) => {
      if (res?.payload?.status == 200) {
        setLoader(false);
      }
      setLoader(false);
    });
  }, [dispatch]);

  useEffect(() => {
    if (getApplicationMasterReportList?.data) {
      const filters = {
        FID: filter,
        ApplicantName: filterApplicantName,
        MoholloName: filterMoholloName,
        AppliedDate: selectDateData,
      };

      // If any filter is active, apply filtering
      if (
        filter ||
        filterApplicantName ||
        filterMoholloName ||
        selectDateData
      ) {
        const filterData = getApplicationMasterReportList?.data.filter(
          (ele) => {
            return Object.entries(filters).every(([key, value]) => {
              if (!value) return true;
              if (key === "ApplicantName" || key === "MoholloName") {
                return ele[key]?.toLowerCase()?.includes(value?.toLowerCase());
              }
              return ele[key] == value;
            });
          },
        );
        setFilterReportData(filterData);
      }
    }
  }, [
    filter,
    filterApplicantName,
    filterMoholloName,
    selectDateData,
    getApplicationMasterReportList,
  ]);

  useEffect(() => {
    setSearchedData(filterReportData);
  }, [filterReportData]);

  useEffect(() => {
    if (filterReportData?.length > 0) {
      const customHeadings = filterReportData?.map((item) => ({
        Type: item?.Type,
        Fid: item?.FID,
        "Application Id": item?.applicationId,
        "Applicant name": item?.ApplicantName,
        "Application Applied Date": item?.AppliedDate,
        "Mohollo name": item?.MoholloName,
        "Mobile number": item?.MobileNo,
        "Adharcard number": item?.AharcardNo,
      }));

      setExcel(customHeadings);
    }
  }, [filterReportData]);

  // Search on table
  const requestSearch = (searched) => {
    if (!searched) return setSearchedData(filterReportData);
    setSearchedData(
      filterReportData?.filter(
        (item) =>
          item?.ApplicantName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()) ||
          item?.FID?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()) ||
          item?.MoholloName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()),
      ),
    );
  };

  //#region start view sahay application

  const handleSahayApplicationView = (viewdata) => {
    const updatedViewData = {
      ...viewdata,
      familyId: viewdata?.FID,
      prevRoute: location?.pathname,
    };
    navigate(`/${rollData}/sahay-report-view`, { state: updatedViewData });
  };

  //#region end view sahay application

  const { rollPermissionData } = useSelector((state) => state.admin);

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();

  const navigate = PagesIndex.useNavigate();
  const rollPermissionNameData =
    rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  if (
    rollPermissionData?.permissionArray?.includes(
      "Sahay Application Master Report_view",
    ) ||
    rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }

  // Initialize data when component loads - this should run only once
  useEffect(() => {
    if (
      getApplicationMasterReportList?.data &&
      getApplicationMasterReportList?.data?.length > 0
    ) {
      // Only set initial data if no filters are active
      if (
        !filter &&
        !filterApplicantName &&
        !filterMoholloName &&
        !selectDateData
      ) {
        setFilterReportData(getApplicationMasterReportList.data);
      }
    }
  }, [getApplicationMasterReportList]);

  // Ensure pageData is populated when searchedData changes
  useEffect(() => {
    if (searchedData?.length > 0) {
      const startIndex = 0;
      const endIndex = Number.parseInt(rowPerPage);
      setPageData(searchedData.slice(startIndex, endIndex));
    } else {
      setPageData([]);
    }
  }, [searchedData, rowPerPage]);

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex res-title-header-flex">
                  <Index.Box className="title-main">
                    <Index.Typography
                      variant="p"
                      component="p"
                      className="page-title"
                    >
                      Sahay Application Master Report
                    </Index.Typography>
                  </Index.Box>
                </Index.Box>
              </Index.Box>

              <Index.Box className="grid-row  sahay-multiple-main">
                <Index.Box sx={{ width: 1 }} className="grid-main">
                  <Index.Box
                    display="grid"
                    className="app-report-row"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                  >
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <PagesIndex.Search
                          className="search sahay-multiple-search"
                          onChange={(e) => requestSearch(e.target.value)}
                        >
                          <PagesIndex.StyledInputBase placeholder="Search" />
                        </PagesIndex.Search>
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="multiple-autocomplet-control"
                          options={getApplicationMasterReportList?.data || []}
                          getOptionLabel={(option) => option?.FID?.toString()}
                          onChange={(value, newvalue) => {
                            setFilter(newvalue?.FID);
                          }}
                          filterOptions={(options, { inputValue }) => {
                            const inputLowerCase = inputValue?.toLowerCase();
                            const uniqueFamilyId = new Set();
                            return options?.filter((option) => {
                              const familyId =
                                option?.FID?.toString()?.toLowerCase();
                              // Check unique
                              if (uniqueFamilyId?.has(familyId)) {
                                return false;
                              }
                              // Check search
                              if (familyId?.includes(inputLowerCase)) {
                                uniqueFamilyId?.add(familyId);
                                return true;
                              }
                              return false;
                            });
                          }}
                          renderInput={(params) => (
                            <Index.TextField {...params} label="FID" />
                          )}
                        />
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="multiple-autocomplet-control"
                          options={getApplicationMasterReportList?.data || []}
                          getOptionLabel={(option) =>
                            option?.ApplicantName || ""
                          }
                          onChange={(value, newvalue) => {
                            setFilterApplicantName(newvalue?.ApplicantName);
                          }}
                          filterOptions={(options, { inputValue }) => {
                            const inputLowerCase = inputValue?.toLowerCase();
                            const uniqueNames = new Set();
                            return options?.filter((option) => {
                              const name = option?.ApplicantName?.toLowerCase();
                              // Check unique
                              if (uniqueNames?.has(name)) {
                                return false;
                              }
                              // Check search
                              if (name?.includes(inputLowerCase)) {
                                uniqueNames?.add(name);
                                return true;
                              }
                              return false;
                            });
                          }}
                          renderInput={(params) => (
                            <Index.TextField
                              {...params}
                              label="Applicant Name"
                            />
                          )}
                        />
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main">
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          className="multiple-autocomplet-control"
                          options={getApplicationMasterReportList?.data || []}
                          getOptionLabel={(option) => option?.MoholloName || ""}
                          onChange={(value, newvalue) => {
                            setFilterMoholloName(newvalue?.MoholloName);
                          }}
                          filterOptions={(options, { inputValue }) => {
                            const inputLowerCase = inputValue?.toLowerCase();
                            const uniqueMohollos = new Set();
                            return options?.filter((option) => {
                              const mohollo =
                                option?.MoholloName?.toLowerCase();
                              // Check unique
                              if (uniqueMohollos?.has(mohollo)) {
                                return false;
                              }
                              // Check search
                              if (mohollo?.includes(inputLowerCase)) {
                                uniqueMohollos?.add(mohollo);
                                return true;
                              }
                              return false;
                            });
                          }}
                          renderInput={(params) => (
                            <Index.TextField {...params} label="Mohollo Name" />
                          )}
                        />
                      </Index.Box>
                    </Index.Box>
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 6",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="sahay-multiple-input-main common-date-picker-custom date-input-box">
                        <Index.LocalizationProvider
                          dateAdapter={Index.AdapterDayjs}
                          sx={{ position: "absolute" }}
                        >
                          <Index.DemoContainer components={["DatePicker"]}>
                            <Index.DatePicker
                              label="Application Applied Date"
                              name="AppliedDate"
                              onChange={(value) => {
                                setSelectDateData(
                                  moment(value.$d).format("YYYY-MM-DD"),
                                );
                              }}
                              format="YYYY-MM-DD"
                              sx={{
                                width: "100%",
                              }}
                              slotProps={{
                                textField: {
                                  size: "small",
                                  error: false,
                                },
                              }}
                            />
                          </Index.DemoContainer>
                        </Index.LocalizationProvider>
                      </Index.Box>
                    </Index.Box>
                    {filterReportData?.length > 0 && (
                      <>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 4",
                            lg: "span 4",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="sahay-multiple-input-main">
                            <Index.Box
                              Box
                              className="res-auto-left common-button blue-button  multiple-download-btn  res-blue-button"
                            >
                              <FileExcel apiData={excel} fileName={fileName} />
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 5",
                            lg: "span 5",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="sahay-multiple-input-main">
                            <Index.Box
                              Box
                              sx={{ justifyContent: "end" }}
                              className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                            >
                              <Index.Button onClick={handlePrint}>
                                Print
                              </Index.Button>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      </>
                    )}
                  </Index.Box>
                </Index.Box>
              </Index.Box>

              <Index.Box className="table-list">
                <Index.TableContainer
                  sx={{ maxHeight: 480 }}
                  className="table-container user-master-container scroll-table common-table-container-custom"
                >
                  <Index.Table
                    stickyHeader
                    aria-label="sticky table"
                    className="table-design-main barge-table re-payment-table"
                  >
                    <Index.TableHead className="user-master-head">
                      <Index.TableRow className="user-master-tr">
                        <Index.TableCell className="user-master-th">
                          Type
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Fid
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Application Id
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Applicant Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Application Applied Date
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Mohollo Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Mobile No.
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Adharcard No.
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>

                    <Index.TableBody className="user-master-tbody">
                      {pageData?.length > 0 ? (
                        pageData?.map((data, index) => (
                          <Index.TableRow
                            key={index}
                            className="user-master-tr"
                            onClick={() => handleSahayApplicationView(data)}
                            sx={{ cursor: "pointer" }}
                          >
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-role-name">
                                {data?.Type === "1" || data?.Type === 1
                                  ? "Vastipatrak"
                                  : "Non-Vastipatrak"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-details-name">
                                {data?.FID || "-"}
                              </Index.Box>
                            </Index.TableCell>
                               <Index.TableCell className="user-master-td">
                                                          <Index.Box className="user-details-name">
                                                            {data?.applicationId || "-"}
                                                          </Index.Box>
                                                        </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-email-name">
                                {data?.ApplicantName || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.AppliedDate || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.MoholloName || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.MobileNo || "-"}
                              </Index.Box>
                            </Index.TableCell>
                            <Index.TableCell className="user-master-td">
                              <Index.Box className="user-number-name">
                                {data?.AharcardNo || "-"}
                              </Index.Box>
                            </Index.TableCell>
                          </Index.TableRow>
                        ))
                      ) : (
                        <PagesIndex.NoRecordFound colSpan={6} />
                      )}
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
              </Index.Box>
              <Index.Box className="pagination-design flex-end">
                <RowPerPageDropdown
                  rowPerPage={rowPerPage}
                  setRowPerPage={setRowPerPage}
                />
                <Index.Stack spacing={2}>
                  <Pagination
                    fetchData={searchedData}
                    setPageData={setPageData}
                    pageData={pageData}
                    rowPerPage={rowPerPage}
                  />
                </Index.Stack>
              </Index.Box>
            </Index.Box>
          </Index.Box>
          <Index.Box sx={{ display: "none" }}>
            <PrintReport
              componentRef={componentRef}
              tableData={excel}
              reportName={[{ type: "RepaymentReport" }]}
            />
          </Index.Box>
        </>
      )}
    </>
  );
}
